import withRouter from 'Common/withRouter';
import OptionesMenuView from 'feature/security/OptionsmenusFeature/feature/OptionesMenuView/OptionesMenuView';

const OptionsMenus = (props: any) => {
  document.title = 'Login | POS Carnet';

  return <OptionesMenuView></OptionesMenuView>;
};

export default withRouter(OptionsMenus);
